var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.NewBlogCarousel,{attrs:{"heading":_vm.widget.widget.heading,"data":_vm.widget.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }